
function setCoaches(data){
    return{
        type : "SET_COACHES",
        payload : data
    }
}

export {  
    setCoaches
}